<template>
    <div class="row">
        <div class="col-12 mt-3">
            <h3 class="text-primary fs-lg-4 font-poppins-semibold">
                LOCATION/POSITION DISPLAY
            </h3>
        </div>
        <div class="col-12 mt-3">
            <s-form @submit="downloadReport" class="row">
                <div class="col-lg-2">
                    <validated-select v-model="model.storage_type" :options="typeOptions" class="c-input-select field-required"
                                      label="Storage Type" @input="StorageOptions" :rules="{required:true}"
                    ></validated-select>
                </div>
                <div class="col-lg-2">
                    <validated-select v-model="model.storage_name" class="c-input-select field-required" label="Storage No"
                                      :options="storageNameOptions" :rules="{required:true}"></validated-select>
                </div>
                <div class="col-lg-2">
                    <validated-select :options="reportTypeOptions"
                                      class="field-required c-input-select "
                                      label="Download Format"
                                      :rules="{required:true}"
                                      v-model="model.format_type"/>
                </div>
                <div class="row mt-lg-9">
                    <div class="col-12">
                        <div class="fl-x fl-j-e">
                            <div class="btn-group">
                                <btn class="text-right"
                                     text="Download"
                                     loading-text="Please Wait..."
                                     :loading="loading"
                                />
                                <btn type="reset" @click="BackToHome" text="Cancel" design="basic-b" class="px-4"/>
                            </div>
                        </div>
                    </div>
                </div>
            </s-form>

        </div>

    </div>

</template>

<script>
import urls from '../../../../data/urls';
import axios from 'secure-axios';
import masterURLs from '../../../../data/masterURLs';

export default {
    name: 'bullLocationSemenStorageDisplay',
    data () {
        return {
            model: {
                storage_type: '',
                storage_name: '',
                format_type: ''
            },
            storageNameOptionsURL: masterURLs.master.storageType.vueSelect,
            storageNameOptions: [],
            typeOptions: [
                {
                    label: 'OMR',
                    value: 'OMR'
                },
                {
                    label: 'JUMBO',
                    value: 'JUMBO'
                }
            ],
            loading: false,
            reportTypeOptions: [
                { label: 'Excel', value: 'Excel' },
                { label: 'Pdf', value: 'Pdf' }
            ]
        };
    },
    methods: {
        BackToHome () {
            this.$router.push({ path: '/reports/' });
        },
        async StorageOptions () {
            this.model.storage_name = '';
            const response = await axios.get(this.storageNameOptionsURL + '?storage_type=' + this.model.storage_type);
            this.storageNameOptions = response.data.data;
        },
        async downloadReport () {
            try {
                this.loading = true;
                const response = await axios.form(urls.reports.bulls.bullLocationSemenStorageDisplay, this.model);
                const json = response.data;
                if (json.error === false) {
                    this.loading = false;
                    window.open(json.url);
                } else {
                    this.loading = false;
                    this.$notify(json.message, 'Oops!', { type: 'warning' });
                }
            } catch (error) {
                this.$notify(
                    'Something Went Wrong..!!',
                    error.response.status + ' ' + error.response.statusText,
                    { type: 'danger' }
                );
                this.loading = false;
            }
        }

    }
};
</script>

<style scoped>

</style>
